export const UNEXPECTED_ERROR =
  'Oops, something went wrong, please try again!';
